import { Divider, Stack } from '@mui/material';

import { UnstyledButton } from '@/components/form/baseInputs/Button/UnstyledButton';
import { ChevronRightIcon } from '@/components/icons/ChevronRightIcon';
import { RichListItemRow } from '@/components/lists/RichListItem/RichListItemRow';
import { DialogModal } from '@/components/modals/DialogModal/DialogModal';
import { COLORS } from '@/styles/tokens/colors';

import type { AppNotification } from '../../NotificationContext/context/NotificationsContext.context';

interface ValidationQuestionsHouseholdModalProps {
  notifications: AppNotification[];
  onClose: () => void;
  onSelect: (notification: AppNotification) => void;
}

export function ValidationQuestionsHouseholdModal({
  notifications,
  onClose,
  onSelect,
}: ValidationQuestionsHouseholdModalProps) {
  return (
    <DialogModal
      isOpen
      onClose={onClose}
      heading="Select household"
      subheading="Choose a household to review its validation questions."
      dialogContentSx={{ minHeight: 200 }}
    >
      <Stack spacing={1} divider={<Divider />}>
        {notifications.map((notification) => (
          <UnstyledButton
            key={notification.id}
            aria-label={
              notification.household?.displayName ?? 'Unknown household'
            }
            onClick={() => onSelect(notification)}
            sx={{
              textAlign: 'left',
              ':hover': { backgroundColor: COLORS.FUNCTIONAL.HOVER },
              ':focus-visible': {
                outline: 'solid black 2px',
                outlineOffset: -2,
              },
            }}
          >
            <RichListItemRow
              heading={
                notification.household?.displayName ?? 'Unknown household'
              }
              RightContent={
                <ChevronRightIcon size={16} color={COLORS.TEXT.SECONDARY} />
              }
            />
          </UnstyledButton>
        ))}
      </Stack>
    </DialogModal>
  );
}
